// extracted by mini-css-extract-plugin
export default {"rightPanel__contentContainer":"RightPanels_rightPanel__contentContainer__deUQ-","rightPanel__panels":"RightPanels_rightPanel__panels__WZVL3"};